import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBackendAuth } from './BackendAuthProvider.jsx';

const AuthenticatedTemplate = ({ children }) => {
  const { isAuthenticated, companyValid, refreshData } = useBackendAuth();
  const { t } = useTranslation('common');
  const [checking, setChecking] = useState(false);

  if (!isAuthenticated) {
    return null;
  }

  if (companyValid === false) {
    return (
      <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4 text-center">
          {/* Warning Icon */}
          <div className="mx-auto flex items-center justify-center w-16 h-16 rounded-full bg-yellow-100 mb-6">
            <svg className="w-8 h-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>

          <h2 className="text-xl font-semibold text-gray-900 mb-3">
            {t('companyRequired.title')}
          </h2>

          <p className="text-sm text-gray-600 mb-6">
            {t('companyRequired.message')}
          </p>

          <button
            onClick={async () => {
              setChecking(true);
              try {
                await refreshData();
              } finally {
                setChecking(false);
              }
            }}
            disabled={checking}
            className="inline-flex items-center px-6 py-2.5 bg-brand-primary text-white text-sm font-medium rounded hover:bg-brand-primaryHover transition-colors disabled:opacity-50"
          >
            {checking && (
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            )}
            {checking ? t('companyRequired.checking') : t('companyRequired.refresh')}
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthenticatedTemplate;
